import React, { useState, useEffect } from 'react';
import { Box, Container, makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';
import { useSelector } from 'react-redux';
import Toolbar from './Toolbar';
import Results from './Results';
import { selector as UserSelector } from '../../../redux/ducks/user';
import TemplateService from '../../../services/TemplateService';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  brandCard: {
    height: '100%'
  }
}));

const TemplateListView = () => {
  const classes = useStyles();
  const [templates, setTemplates] = useState([]);
  const { token } = useSelector(UserSelector);

  const getTemplates = async () => {
    const response = await TemplateService.getAll();
    if (response.code === 200) {
      setTemplates(response.data);
    }
  };

  useEffect(() => {
    if (token !== null) {
      getTemplates();
    }
  }, []);

  return (
    <Page className={classes.root} title="Templates">
      <Container maxWidth={false}>
        {templates.length > 0 && <Toolbar />}
        <Box mt={3}>
          <Results data={templates} />
        </Box>
      </Container>
    </Page>
  );
};

export default TemplateListView;
